import React, { useEffect, useState } from 'react';
import {Grid, SnackbarContent, IconButton, Button, Modal, Backdrop, useTheme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const TrialExpirationSnackbar = ({ handleSnackbarClose, deadline, workspace }) => {
  const [open, setOpen] = useState((window.location.href.includes('first_trial') === true || checkTimestamp()==false) ? false : true);
  const theme = useTheme();

  const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());

  if(window.location.href.includes('first_trial')===true){setTimestamp();}

  function calculateRemainingTime() {
    const currentTime = Math.floor(Date.now() / 1000);
    const deadlineTime = Math.floor(new Date(deadline).getTime() / 1000);
    const remainingSeconds = deadlineTime - currentTime;
    if (remainingSeconds <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const days = Math.floor(remainingSeconds / (24 * 60 * 60));
    const hours = Math.floor((remainingSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(remainingSeconds % 60);
    return { days, hours, minutes, seconds };
  }

  function setTimestamp() {
    localStorage.setItem('free_trial_popup_timestamp', Date.now());
  }

  function checkTimestamp() {
    const storedTimestamp = localStorage.getItem('free_trial_popup_timestamp');
    return storedTimestamp && Date.now() - parseInt(storedTimestamp, 10) >= 12 * 60 * 60 * 1000;
  }


  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleClose = (event, reason) => {
    setTimestamp();
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    handleSnackbarClose();
  };

  const snackbarStyle = {
    background: `linear-gradient(to bottom, ${theme.palette.primary.main}, white)`,
    color: '#fff',
    borderRadius: '8px',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    fontSize: '16px',
    fontWeight: 'bold',
    boxShadow: 'none',
    width: '400px',
    margin: '0 auto',
    marginTop: '80px',
    border: 'none',
    outline: 'none',
  };

  const buttonStyle = {
    marginTop: '12px',
    marginBottom: '0px',
    textAlign: 'center',
  };

  const formatTime = (value) => {
    return value.toString().padStart(2, '0');
  };

  return (
    <Modal open={open} onClose={handleClose} BackdropComponent={Backdrop} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
      <SnackbarContent
        style={snackbarStyle}
        message={
          <div style={{ color: '#fff', textAlign: 'center' }}>
            <div style={{fontSize:'30px', color:'white', fontFamily:'Comfortaa', cursor:'pointer'}}>Prospect<span style={{color:theme.palette.secondary.main}}>Safari</span>{(workspace!=undefined && workspace.custom_logo!=undefined)?<span style={{fontSize:'15px', marginLeft:'5px'}}>{" and "}<img style={{width:'30px', marginLeft:'5px', marginTop:'4px', marginBottom:'-4px'}} src={'/images/custom_logos/'+workspace.custom_logo}/></span>:null}</div>
            <img style={{position:'absolute', width:'20px', cursor:'pointer', marginLeft:(workspace!=undefined && workspace.custom_logo!=undefined)?'-125px':'-85px', marginTop:(workspace!=undefined && workspace.custom_logo!=undefined)?'-30px':'-30px'}} src='/images/logo.png'/>
            <div style={{ marginBottom: '4px', color:'white'}}>
              {formatTime(remainingTime.days)} days, {formatTime(remainingTime.hours)} hours, {formatTime(remainingTime.minutes)} minutes, {formatTime(remainingTime.seconds)} seconds
            </div>
            <div style={{ fontSize: '14px' }}>
              Ready to start your subscription?
            </div>
            <div style={{ fontSize: '14px' }}>
              Complete your registration now
            </div>
            <Grid container>
            <Grid item xs={6}><Button variant="contained" color="secondary" onClick={()=>{window.location.href='/my/personal/customer/portal'}} style={buttonStyle}>Complete</Button></Grid>
            <Grid item xs={6}><Button variant="contained" color="primary" onClick={handleClose} style={buttonStyle}>Not now</Button></Grid>
            </Grid>
          </div>
        }
      />
    </Modal>
  );
};

export default TrialExpirationSnackbar;
